<template>
    <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 bg-08">
        <div class="centrar_div" @click="Cargar">
            <h1 class="superbig color_Gris02 text-center">{{form.total - form.limit}}+</h1>
            <div class="col-12">
                <div class="row justify-content-center" >
                    <p class="medium color_Gris02 mr-2" >Cargar</p>
                    <h3><i class="fas fa-play-circle color_Azul" ></i></h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['value'],
    data() {
        return {
            form:this.value
        }
    },methods: {
        Cargar(){
            this.form.limit = this.form.limit  + 11;//= this.form.value.length;
            this.$emit("input", this.form);
        }
    },
}
</script>